<template>
  <div>
    <el-row>
      <el-col :span="8">
        <el-upload
          drag
          :action="action"
          :before-upload="fnBeforeUpload"
          :on-success="audioSuccess"
          :on-remove="handleAudioRemove"
          :http-request="fnUploadRequest"
          accept=".mp3"
          :limit="1">
          <div style="font-size: 12px; line-height: 26px;display: flex; flex-wrap: wrap;align-items: center; height: 130px;">
            <div>
              <div style="width: 100%;"><i style="font-size: 28px" class="el-icon-upload2"></i></div>
              <div style="width: 100%;text-align: center;">拖拽或<em style="color: #1c9dff">点击上传</em></div>
              <div style="width: 100%;text-align: center;">文件大小不超过 100M</div>
            </div>
          </div>
        </el-upload>
      </el-col>
      <el-col :span="5">
        <el-slider @change="changeTime" :format-tooltip="formatTime" :max="music.maxTime" v-model="music.currentTime" style="width: 100%;"></el-slider>
      </el-col>
      <el-col :span="5" style="padding-left: 10px;color:#909399;font-size: 14px" v-loading="music.maxTime < 1">
        {{formatTime(music.currentTime)}}/{{formatTime(music.maxTime)}}
      </el-col>
      <!--  播放按钮    -->
      <el-col :span="2">
        <i @click="play" id="play" :class="music.isPlay ? 'el-icon-video-pause' : 'el-icon-video-play'" class="m-icon-hover"></i>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" size="small" plain>{{ duration }} 秒</el-button>
      </el-col>
    </el-row>
    <audio :ref="musicId" loop v-if="this.$httpConf.ossURL !== '' && nowAudioUrl !== ''">
      <source :src="this.$httpConf.ossURL + nowAudioUrl" type="audio/mpeg">
    </audio>
  </div>
</template>

<script>
import {v4 as uuidv4} from 'uuid'
export default {
  name: 'UploadAudio',
  data () {
    return {
      music: {
        isPlay: false,
        currentTime: 0,
        maxTime: 0,
        volume: 100
      },
      timer: null
    }
  },
  props: {
    // 父组件传递音频链接
    nowAudioUrl: {
      type: String
    },
    // 父组件传递音频链接
    accessKeys: {
      type: Object
    },
    // 父组件传递音频链接
    duration: {
      type: Number
    },
    // 父组件传递储存路径
    action: {
      type: String
    },
    // 父组件传递储存路径
    musicId: {
      type: String
    }
  },
  watch: {
    // 监听父组件传递的url, 赋值播放
    nowAudioUrl: function (val) {
      this.music = {
        isPlay: false,
        currentTime: 0,
        maxTime: 0,
        volume: 100
      }
      if (this.$refs[this.musicId] !== undefined) {
        this.$refs[this.musicId].res = this.$httpConf.ossURL + val
      }
    }
  },
  methods: {
    // 上传成功时执行
    audioSuccess (response, file, fileList) {
      if (response.res.status === 200) {
        this.$emit('audioSuccess', {'url': response.name})
        this.$refs[this.musicId].load()
        this.$message.success('上传成功')
      }
    },
    // 删除上传文件时执行
    handleAudioRemove (file, fileList) {
      this.$emit('handleAudioRemove')
    },
    // 每秒监听音频状态
    listenMusic () {
      if (!this.$refs[this.musicId]) {
        return
      }
      if (this.$refs[this.musicId].readyState) {
        this.music.maxTime = this.$refs[this.musicId].duration
        this.$emit('maxTime', {'duration': this.$refs[this.musicId].duration})
      }
      this.music.isPlay = !this.$refs[this.musicId].paused
      this.music.currentTime = this.$refs[this.musicId].currentTime
    },
    // 播放与暂停
    play () {
      if (this.$refs[this.musicId].paused) {
        this.$refs[this.musicId].play()
      } else {
        this.$refs[this.musicId].pause()
      }
      this.music.isPlay = !this.$refs[this.musicId].paused
      this.$nextTick(() => {
        document.getElementById('play').blur()
      })
    },
    // 滑动进度改变时
    changeTime (time) {
      this.$refs[this.musicId].currentTime = time
    },
    // 时间转换格式
    formatTime (time) {
      let it = parseInt(time)
      let m = parseInt(it / 60)
      let s = parseInt(it % 60)
      return (m < 10 ? '0' : '') + parseInt(it / 60) + ':' + (s < 10 ? '0' : '') + parseInt(it % 60)
    },
    // 时长转换精确到秒
    formatTimeSecond (time) {
      return parseInt(time)
    },
    // 限制上传文件大小
    fnBeforeUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 150
      if (!isLt2M) {
        this.$message.warning('上传文件大小不能超过 150MB!')
      }
      return isLt2M
    },
    /**
     * @description [fnUploadRequest 覆盖默认的上传行为，实现自定义上传]
     */
    async fnUploadRequest (option) {
      if (this.accessKeys.accessKeyId === '') {
        return this.$message.error('未获取到ossKey,请刷新页面重试')
      }
      try {
        let vm = this
        vm.disabled = true
        let oss = require('ali-oss')
        let client = oss({
          accessKeyId: vm.accessKeys.accessKeyId,
          accessKeySecret: vm.accessKeys.accessKeySecret,
          bucket: vm.accessKeys.bucket,
          region: vm.accessKeys.region,
          success_action_status: '200'
        })
        let file = option.file
        // 获取文件后缀
        const point = file.name.lastIndexOf('.')
        let suffix = file.name.substr(point)
        let fileName = file.name.substr(0, point)

        // 拼接文件名称
        let audioName = uuidv4().replace(/-/g, '') + '_' + new Date().getTime()
        let fileNames = `${audioName}_${fileName}${suffix}`
        // 分片上传文件
        let ret = await client.multipartUpload(option.action + fileNames, file, {
          progress: async function (p) {
            let e = {}
            e.percent = p * 100
            option.onProgress(e)
          }
        })
        if (ret.res.status === 200) {
          return ret
        } else {
          option.onError('上传失败')
        }
      } catch (error) {
        option.onError('上传失败')
        this.$message.error(error.message)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      // 每秒监听播放进度
      this.timer = setInterval(this.listenMusic, 1000)
    })
  },
  // 组件销毁时取消监听
  beforeDestroy () {
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>

<style>
.el-upload-dragger {
  width: 170px;
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>



// WEBPACK FOOTER //
// src/components/public/UploadAudio.vue